import React from 'react';
import { Input, Button, Spin, Alert } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { usePW0113F1Form } from './hooks/usePW0113F1Form';

const PW0113F1Form: React.FC = () => {
  const {
    loading,
    oldPassword, setOldPassword,
    newPassword, setNewPassword,
    confirmPassword, setConfirmPassword,
    submit, resetForm,
  } = usePW0113F1Form();

  const handleSubmit = async () => {
    await submit();
  };

  return (
    <Spin spinning={loading}>
      <div className="max-w-lg mx-auto p-6">
        {/* Title */}
        <h2 className="text-xl font-bold mb-4">
          個人密碼更新 (pw0113f1)
        </h2>

        {/* Info Alert */}
        <Alert
          message="密碼安全要求"
          description="新密碼必須至少6位，且必須包含字母和數字。新密碼不可與舊密碼相同。"
          type="info"
          showIcon
          className="mb-6"
        />

        {/* Form Fields */}
        <div className="space-y-4 mb-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              舊密碼 <span className="text-red-500">*</span>
            </label>
            <Input.Password
              prefix={<LockOutlined />}
              value={oldPassword}
              onChange={e => setOldPassword(e.target.value)}
              placeholder="請輸入舊密碼"
              style={{ maxWidth: 400 }}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              新密碼 <span className="text-red-500">*</span>
            </label>
            <Input.Password
              prefix={<LockOutlined />}
              value={newPassword}
              onChange={e => setNewPassword(e.target.value)}
              maxLength={50}
              placeholder="請輸入新密碼（至少6位，含字母和數字）"
              style={{ maxWidth: 400 }}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              確認新密碼 <span className="text-red-500">*</span>
            </label>
            <Input.Password
              prefix={<LockOutlined />}
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
              maxLength={50}
              placeholder="請再次輸入新密碼"
              style={{ maxWidth: 400 }}
            />
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex items-center gap-2">
          <Button type="primary" onClick={handleSubmit} loading={loading}>
            確認修改
          </Button>
          <Button onClick={resetForm}>
            清除
          </Button>
        </div>
      </div>
    </Spin>
  );
};

export default PW0113F1Form;
